import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import styles from "./carousel.module.scss";

interface CarouselProps {
  children: React.ReactNode[];
}

const Carousel: React.FC<CarouselProps> = ({ children }) => {
  const carousel = useRef<HTMLDivElement>(null);
  const card = useRef<HTMLDivElement>(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const [currentPosition, setCurrentPosition] = useState<
    "start" | "middle" | "end"
  >("start");

  const updateScrollPosition = () => {
    const { clientWidth, scrollWidth, scrollLeft } = carousel.current!;

    if (scrollLeft === 0) {
      setCurrentPosition("start");
    } else if (scrollWidth - scrollLeft === clientWidth) {
      setCurrentPosition("end");
    } else {
      setCurrentPosition("middle");
    }
  };

  useEffect(() => {
    if (carousel.current!.scrollWidth > 0) {
      setIsScrollable(true);
      carousel.current!.addEventListener("scroll", updateScrollPosition, {
        passive: true,
      });
    } else setIsScrollable(false);
  }, []);

  const handleForwardClick = (event: React.MouseEvent<HTMLElement>) => {
    const { current } = carousel;
    event.preventDefault();
    current!.scrollLeft += card.current!.offsetWidth;
  };

  const handleBackwardClick = (event: React.MouseEvent<HTMLElement>) => {
    const { current } = carousel;
    event.preventDefault();
    current!.scrollLeft -= card.current!.offsetWidth;
  };

  return (
    <div className={styles.container}>
      {isScrollable && (
        <button
          className={`
          ${styles.btn}
          ${currentPosition === "start" ? styles.disabledBtn : ""}
        `}
          disabled={currentPosition === "start"}
          onClick={handleBackwardClick}
        >
          <IoIosArrowBack />
        </button>
      )}
      <div className={styles.carousel} ref={carousel}>
        {children.map((item, index) => (
          <div key={index} className={styles.item} ref={card}>
            {item}
          </div>
        ))}
      </div>
      {isScrollable && (
        <button
          className={`
          ${styles.btn}
          ${currentPosition === "end" ? styles.disabledBtn : ""}
        `}
          disabled={currentPosition === "end"}
          onClick={handleForwardClick}
        >
          <IoIosArrowForward />
        </button>
      )}
    </div>
  );
};

export default Carousel;
